<template>
  <div class="home">
    <WhatsAppBtn class="whatsapp fixed-button"/>
    <section id="hero">
      <img src="../assets/img/hero-img.png" alt="lavadoras" class="hero-img">
      <div class="container text-start text-container">
        <div class="row">
          <div class="col-md-7  col-12 hero-text">
            <h1 class="light-blue"><span>Compromiso.</span> <br>
              <span class="deep-blue">Cercanía.</span><br>
              <span>Experiencia.</span>
            </h1>
            <h4 class="fresh-blue bajada-hero">Somos tu proveedor de confianza en lavandería y alimentación.</h4>
            <ButtonComp 
              :btnColor="'btn-primary'" 
              :buttonText="'Conoce nuestros servicios'"
              :displayLink="true"
              :hashTag="'#services'"
              />
          </div>
        </div>
      </div>
    </section>
    <section id="values">
      <div class="container-desktop">
        <div class="row cards-container">
          <div class="col-12 col-lg-3 col-card">
            <ValueCard 
              :title="'Atención a empresas 24/7'"
              :text="'Para responder a los ritmos y exigencias de la industria.'"
              :icon="'cuidado.png'"
              :altText="'Icono de cuidado'"
              data-aos="fade-up" 
              data-aos-easing="ease-in-sine" 
              data-aos-offset="0" 
              data-aos-duration="500"
            />
          </div>
          <div class="col-12 col-lg-3 col-card">
            <ValueCard 
              :title="'Procesos eficientes y conscientes'"
              :text="'Estamos en constante optimización de nuestros procesos para cuidar el agua y otros recursos.'"
              :icon="'innovacion.png'"
              :altText="'Icono de innovacion'"
              data-aos="fade-up" 
              data-aos-easing="ease-in-sine" 
              data-aos-offset="200" 
              data-aos-duration="500"
            />
            />
          </div>
          <div class="col-12 col-lg-3 col-card">
            <ValueCard 
              :title="'Somos un equipo de mujeres'"
              :text="'Entregamos confianza, colaboración y calidez en nuestro servicio.'"
              :icon="'emprendimiento.png'"
              :altText="'Icono de mujer en cohete'"
              data-aos="fade-up" 
              data-aos-easing="ease-in-sine" 
              data-aos-offset="300" 
              data-aos-duration="500"
            />
            />
          </div>
          <div class="col-12 col-lg-3 col-card">
            <ValueCard 
              :title="'Acreditación y experiencia'"
              :text="'Más de 10 años en el mercado, acreditados por la minería.'"
              :icon="'compromiso.png'"
              :altText="'Icono de compromiso'"
              data-aos="fade-up" 
              data-aos-easing="ease-in-sine" 
              data-aos-offset="400" 
              data-aos-duration="500"
            />
            />
          </div>
        </div>
      </div>
    </section>
    <section id="services" class="container">
      <div id="lavanderia" class="text-center text-lg-start">
        <div class="row">
          <div 
            class="col-lg-6 col-12"
            data-aos="fade-right" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="0" 
            data-aos-duration="500"
            >
            <div 
              class="d-flex mb-4"
              >
              <img src="../assets/icons/lavanderia.svg" alt="icono lavadora" class="me-4 icono-servicio img-fluid">
              <h2 class="deep-blue">Lavandería Industrial.</h2>
            </div>
            <p class="ws-16">Nos preocupamos del cuidado de las prendas y  cumplimos con los tiempos estipulados.</p>
            <ul class="ws-16 pt-3 mb-4 text-start">
              <li><img src="../assets/svg/forma_celeste_2.svg" alt="forma celeste">Lavado y entrega de ropa de trabajo</li>
              <li><img src="../assets/svg/forma_celeste_2.svg" alt="forma celeste">Confeccion de morrales rotulados</li>
              <li><img src="../assets/svg/forma_celeste_2.svg" alt="forma celeste">Gestión eficiente de recursos e insumos</li>
              <li><img src="../assets/svg/forma_celeste_2.svg" alt="forma celeste">Cuidamos tu ropa como en casa</li>
            </ul>
            <p class="ws-16 pb-4">También atendemos público general. Sólo dirígete a <router-link to="/#sucursales" class="underline">nuestra sucursal</router-link>.</p>
            <ButtonComp 
              :btnColor="'btn-primary'" 
              :buttonText="'Quiero Cotizar'"
              :linkBtn="''"
              data-tally-open="nrZeAo"
              data-tally-layout="modal"
              data-tally-width="700"
              />
          </div>
          <div 
            class="col-lg-6 col-12 pt-3"
            data-aos="fade-left" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="0" 
            data-aos-duration="500"
            >
            <div class="row row-img">
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/lavanderia-1.jpg" alt="">
              </div>
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/lavanderia-2.jpg" alt="">
              </div>
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/lavanderia-3.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="alimentacion" class="text-center text-lg-end">
        <div class="row">
          <div 
            class="col-lg-6 col-12 order-lg-0 order-1"
            data-aos="fade-right" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="0" 
            data-aos-duration="500"
            >
            <div class="row row-img">
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/alimentacion-1.jpg" alt="" class="cover">
              </div>
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/alimentacion-2.png" alt=""class="cover">
              </div>
              <div class="col-lg col-12 img-cont">
                <img src="../assets/img/alimentacion-3.png" alt="" class="cover">
              </div>
            </div>
          </div>
          <div 
            class="col-lg-6 col-12 order-lg-1 order-0 text-lg-end mb-4"
            data-aos="fade-left" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="0" 
            data-aos-duration="500"
            >
            <div class="d-flex mb-2">
              <img src="../assets/icons/alimentacion.svg" alt="icono lavadora" class="me-4 icono-servicio img-fluid">
              <h2 class="fresh-blue">Servicio de Alimentación.</h2>
            </div>
            <p class="ws-16 pb-3">Nos preocupamos de tus trabajadores y su alimentación en faena, con alternativas prácticas y muy ricas.</p>
            <ul class="ws-16 pt-3 mb-4 text-lg-end text-start">
              <li><img src="../assets/svg/forma_verde_2.svg" alt="forma celeste">Colaciones frías</li>
              <li><img src="../assets/svg/forma_verde_2.svg" alt="forma celeste">Colaciones preparadas</li>
              <li><img src="../assets/svg/forma_verde_2.svg" alt="forma celeste">Opciones flexibles adaptables a cada turno</li>
            </ul>
            <ButtonComp 
              :btnColor="'btn-terciary'" 
              :buttonText="'Quiero Cotizar'"
              data-tally-open="np2QB8"
              data-tally-layout="modal"
              data-tally-width="700"
              />
          </div>

        </div>
      </div>
    </section>
    <div 
      id="cta-1"
      data-aos="fade-top" 
      data-aos-easing="ease-in-sine" 
      data-aos-offset="0" 
      data-aos-duration="500"
    >
      <div class="container text-end">
        <h3 class="white bold">Intercambio con sentido. <br><span class="regular">Cuidado que</span> transforma.</h3>
      </div>
    </div>
    <section id="somos" class="container">
      <div 
        class="row row-somos deep-blue-bg"
        data-aos="fade-right" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="0" 
        data-aos-duration="500"
        >
        <div class="col-lg-3 col-md-5 col-12 p-0">
          <img src="../assets/img/alicia.png" alt="foto alicia" class="img-fluid somos-img">
        </div>
        <div class="col-lg-9 col-md-7 col-12 somos-text-deep">
          <p class="white ws-20 mb-5 mb-lg-0">
            En Mercatur, creemos que <span class="semi-bold">servir es una forma de construir comunidad</span> porque sabemos que nuestra atención cumple un rol fundamental para muchas personas que sostiene el  trabajo diario: mineros, técnicos, operarios, administrativos y comunidades.
          </p>
        </div>
      </div>
      <div 
        class="row row-somos fresh-blue-bg"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="0" 
        data-aos-duration="500"
        >
        <div class="col-lg-9 col-md-7 col-12 somos-text-deep">
          <p class="white ws-20 mt-md-0 pt-md-0 mt-5 pt-5">
            Nuestro nombre proviene del latín mercari: que significa “intercambiar”. <span class="semi-bold">Para nosotras, ese intercambio va más allá de lo económico: es humano, constante y significativo.</span><br>Valorizamos el trabajo de las mujeres dentro de la industria y <span class="semi-bold">cuidamos cada detalle de nuestro trabajo</span>, para así también cuidar a quienes hacen posible que todo funcione.técnicos, operarios, administrativos y comunidades.
          </p>
        </div>
        <div class="col-lg-3 col-md-5 col-12 p-0 ">
          <img src="../assets/img/clothes.png" alt="foto alicia" class="img-fluid somos-img">
        </div>
      </div>
      <div 
        class="row row-somos deep-blue-bg"
        data-aos="fade-right" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="0" 
        data-aos-duration="500"
        >
        <div class="col-lg-3 col-md-5 col-12 p-0">
          <img src="../assets/img/hands.png" alt="foto alicia" class="img-fluid somos-img">
        </div>
        <div class="col-lg-9 col-md-7 col-12 somos-text-deep">
          <p class="white ws-20 mb-5 mb-lg-0">
            Lo que partió como un emprendimiento liderado por una mujer con raíces diaguitas y una visión clara, hoy se proyecta como una empresa en expansión, que integra <span class="semi-bold">innovación, conciencia medioambiental y servicios</span> que responden con profesionalismo a los desafíos reales de la industria.
          </p>
        </div>
      </div>
    </section>
    <div 
      id="cta-2" 
      class="text-center"
      data-aos="fade-top" 
      data-aos-easing="ease-in-sine" 
      data-aos-offset="0" 
      data-aos-duration="500"
      >
      <div class="container">
        <h2>¿Tienes un requerimiento especial?</h2>
        <p class="ws-24 deep-blue pb-5">Nos adaptamos a lo que necesites con un servicio cercano y confiable.</p>
        <ButtonComp 
          :btnColor="'btn-secondary'" 
          :buttonText="'¡Escríbenos!'"
          data-tally-open="w26W7g"
          data-tally-layout="modal"
          data-tally-width="700"
        />
      </div>
    </div>
    <div 
      id="testimonios"
      data-aos="fade-top" 
      data-aos-easing="ease-in-sine" 
      data-aos-offset="100" 
      data-aos-duration="500"
      >
      <div id="carouselTestimonios" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div 
            v-for="(testimonio, idx) in testimonios" 
            :key="idx" 
            :class="['carousel-item', { active: idx === 0 }]">
            <div class="container">
              <div class="row text-lg-start tex-center">
                <div class="col-lg-5 col-12">
                  <h3 class="deep-blue">{{ testimonio.titulo }}</h3>
                </div>
                <div class="col-lg-7 col-12 texto-testimonio">
                  <p class="ws-16">{{ testimonio.texto }}</p>
                  <p class="ws-16">{{ testimonio.autor }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselTestimonios" data-bs-slide="prev">
          <img src="../assets/icons/left_arrow.svg" alt="icono flecha izquierda">
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselTestimonios" data-bs-slide="next">
          <img src="../assets/icons/right_arrow.svg" alt="icono flecha derecha">
        </button>
      </div>
    </div>
    <section id="clientes">
      <div class="logo-marquee">
    <div class="logo-track">
      <div
        v-for="(logo, idx) in logosDuplicados"
        :key="idx"
        class="logo-cliente d-flex justify-content-center align-items-center"
      >
        <img :src="logo" :alt="'logo'" class="img-fluid logo-cliente">
      </div>
    </div>
  </div>
    </section>
    <section id="faqs">
      <div class="row">
        <div 
          class="col-lg-4 col-12"
          data-aos="fade-right" 
          data-aos-easing="ease-in-sine" 
          data-aos-offset="100" 
          data-aos-duration="500"
          >
          <div class="bg-opacity text-center">
            <div class="rotate">
              <h2>¿Tienes dudas?</h2>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12">
          <AccordionDudas />
        </div>
      </div>
    </section>
    <div>
      <div class="titulo-sucursales">
        <h2 class="light-blue">Nuestras <span class="deep-blue">Sucursales</span></h2>
      </div>
      <div id="sucursales">
        <div class="container">
          <div 
            class="sucursal sucursal-1"
            data-aos="zoom-in" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="100" 
            data-aos-duration="500"
            >
            <h4><a href="https://maps.app.goo.gl/wggSuZdEavKPSWB69" target="_blank">Diego de Almagro 535, Copiapó, Chile</a></h4>
            <p class="ws-16">¡Pronto!</p>
          </div>
          <div 
            class="sucursal sucursal-2"
            data-aos="zoom-in" 
            data-aos-easing="ease-in-sine" 
            data-aos-offset="100" 
            data-aos-duration="500"
            >
            <h4><a href="https://maps.app.goo.gl/X7JeMfwj1zCM8Vdz5" target="_blank">Rafael Torreblanca 424,Copiapó, Chile</a></h4>
            <p class="ws-16">Lunes a viernes entre 8:00 y 18:00 hrs.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonComp from '@/components/ButtonComp.vue'
import ValueCard from '@/components/ValueCard.vue';
import { mapState } from 'vuex';
import bailac from '@/assets/logos/bailac.png';
import cummins from '@/assets/logos/cummins.png';
import epiroc from '@/assets/logos/epiroc.png';
import ggi from '@/assets/logos/ggi.png';
import jhonson from '@/assets/logos/jhonson.png';
import reprend from '@/assets/logos/reprend.png';
import westfire from '@/assets/logos/westfire.png';
import AccordionDudas from '@/components/AccordionDudas.vue';
import WhatsAppBtn from '@/components/WhatsAppBtn.vue';

export default {
  name: 'HomeView',
  components: {
    ButtonComp,
    ValueCard,
    AccordionDudas,
    WhatsAppBtn
  },
  data() {
    return {
      logos: [
        bailac,
        cummins,
        epiroc,
        ggi,
        jhonson,
        reprend,
        westfire
      ]
    }
  },
  computed: {
    ...mapState(['testimonios']),
     logosDuplicados() {
    // Duplica el array para que la animación sea continua
    return [...this.logos, ...this.logos];
  }
  }
}
</script>
